<template>
  <div>

  </div>
</template>
<script>

export default {
  created() {
    // MLD-3980
    const module = this.$route.query.module;
    if (module) {
      switch (module) {
        case 'contacts':
          return this.$router.replace({name: `${this.$root.routePrefix}.user_contacts.index`, query: this.$route.query});
        case 'email_lists':
          return this.$router.replace({name: `${this.$root.routePrefix}.mailcoach.lists`, query: this.$route.query});
        case 'send_campaign':
          return this.$router.replace({name: `${this.$root.routePrefix}.mailcoach.campaign.wizard`, query: this.$route.query});
        case 'sent_emails':
          return this.$router.replace({name: `${this.$root.routePrefix}.mailgun.messages`, query: this.$route.query});
      }
    }
    this.$store.dispatch('emailCart/reset');
    this.$router.replace({name: `${this.$root.routePrefix}.email.wizard.template`, query: this.$route.query});
  }
}
</script>
